import { Video } from 'lucide-react';
import { type ComponentType, lazy } from 'react';
import type { RouteObject } from 'react-router';
import type { ModuleDefinition } from '../../app/modules';
import { useMeetingsAvailable } from './api';

/**
 * Відеозустрічі (М20): перелік і календар, картка зустрічі (вхід до кімнати Jitsi, згода на запис, гості, записи,
 * розшифровки, звіт ШІ-12, доручення), налаштування сервера й шаблонів звітів для адміністратора, журнал видалень.
 * У задачі — кнопка «Зустріч» у рядку дій картки. Публічна сторінка гостя /meetings/guest/:token підключена
 * в src/app/router.tsx поза оболонкою (як публічна форма /f/:token).
 */
const TaskMeetingButton = lazy(() => import('./TaskMeetingButton').then((m) => ({ default: m.TaskMeetingButton })));

const page = (load: () => Promise<{ default: ComponentType }>): Pick<RouteObject, 'lazy'> => ({
  lazy: async () => ({ Component: (await load()).default }),
});

const meetingsModule: ModuleDefinition = {
  key: 'meetings',
  label: 'Зустрічі',
  icon: Video,
  basePath: '/meetings',
  scope: 'tasks:read',
  useAccess: useMeetingsAvailable,
  order: 15,
  routes: [
    {
      ...page(() => import('./MeetingsLayout')),
      children: [
        { index: true, ...page(() => import('./MeetingsPage')) },
        { path: 'settings', ...page(() => import('./SettingsPage')) },
        { path: 'deletions', ...page(() => import('./DeletionsPage')) },
      ],
    },
    { path: ':meetingId', ...page(() => import('./card/MeetingPage')) },
  ],
  task: { Toolbar: TaskMeetingButton },
};

export default meetingsModule;
